export default __webpack_public_path__ + "static/emeline-2b13a4a65c235631939bfa2890a718ba.jpg";